import type { WiwState } from '@/store';

export const getTosLoaded = (state: WiwState) => state.data.termsOfService.loaded;
